import { null as zNull } from "zod/v4";

export const disconnectKatanaIntegration = {
  name: "disconnectKatanaIntegration" as const,
  input: zNull(),
  output: zNull(),
};
